import React from 'react';
import { regex_solo_numeros } from '../index';

export const Acta = ({estadoOcultoOConsolidado,setActa,acta,titulo}) => {

     if(estadoOcultoOConsolidado){
        return  <div className="flex flex-col items-start gap-1 cursor-not-allowed">
      <span className="text-xs font-medium text-gray-500 mb-1">{titulo}</span>
      <div className="text-sm font-semibold text-gray-800 bg-gray-50 px-3 py-2 rounded-md border border-gray-200 w-full min-h-[38px] flex items-center">
        {acta || "—"}
      </div>
    </div>
    }

    return <label className="flex flex-col items-start gap-1 cursor-pointer">
      <span className="text-xs font-medium text-gray-700 mb-1">{titulo}</span>                                    
      <input 
        type="text" 
        id="acta-regional-tab" 
        disabled={false}
        value={acta} 
        className="text-sm p-2 border border-gray-300 rounded-md outline-none bg-white focus:border-blue-500 w-full"
        onChange={(e) => (e.target.value === '' || regex_solo_numeros.test(e.target.value)) && setActa(e.target.value)} 
      />
    </label>
};